import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import { ReportStatus } from '../../../../common/enums/reportStatus';
import { translateKey } from '../../../translate';
import { Button } from '../common';

export function AddClarificationButton(props: {
    addClarification?: () => Promise<void>;
    diagnosticReport: IDiagnosticReportGetOne;
}) {
    if (
        props.diagnosticReport.reviewStatus !== ReportStatus.open ||
        !props.diagnosticReport.authorization ||
        !props.diagnosticReport.authorization.canAddDiagnosticReportClarificationRequester ||
        props.diagnosticReport.clarificationQARequester ||
        !props.addClarification
    ) {
        return null;
    }

    return (
        <Button
            automation="askClarification"
            color="secondary"
            large
            onClick={props.addClarification}
            outlined
        >
            {translateKey('diagnosticReport.addClarification')}
        </Button>
    );
}
